"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactFormType = void 0;
const lib_1 = require("@brandfree-front/lib");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const StoresUtil_1 = require("../../util/StoresUtil");
const ContactFormContent_1 = __importDefault(require("./ContactFormContent"));
const ContactFormFooter_1 = __importDefault(require("./ContactFormFooter"));
const ContactFormHeader_1 = __importDefault(require("./ContactFormHeader"));
var ContactFormType;
(function (ContactFormType) {
    ContactFormType[ContactFormType["CONTACT_US"] = 0] = "CONTACT_US";
    ContactFormType[ContactFormType["ACCESS_DATA"] = 1] = "ACCESS_DATA";
    ContactFormType[ContactFormType["LIMIT_PROCESSING"] = 2] = "LIMIT_PROCESSING";
    ContactFormType[ContactFormType["FORGOTTEN"] = 3] = "FORGOTTEN";
    ContactFormType[ContactFormType["DATA_TRANSFER"] = 4] = "DATA_TRANSFER";
    ContactFormType[ContactFormType["CORRECT_DATA"] = 5] = "CORRECT_DATA";
})(ContactFormType || (exports.ContactFormType = ContactFormType = {}));
let ContactForm = class ContactForm extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "heading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "textAreaComment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "setExtraInfoElements", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { translate } = this.translateStore;
                const { contactFormType } = this.props;
                switch (contactFormType) {
                    case ContactFormType.ACCESS_DATA:
                        (0, mobx_1.runInAction)(() => {
                            this.heading = translate('gdpr.privacy.accessData.heading');
                            this.textAreaComment = translate('gdpr.privacy.accessData.textAreaComment');
                        });
                        break;
                    case ContactFormType.FORGOTTEN:
                        (0, mobx_1.runInAction)(() => {
                            this.heading = translate('gdpr.privacy.forgotten.heading');
                            this.textAreaComment = translate('gdpr.privacy.forgotten.textAreaComment');
                        });
                        break;
                    default:
                        (0, mobx_1.runInAction)(() => {
                            this.heading = undefined;
                            this.textAreaComment = undefined;
                        });
                }
            }
        });
        (0, mobx_1.makeObservable)(this);
    }
    render() {
        const { contactFormType, redirectUrlAfterSubmit } = this.props;
        this.setExtraInfoElements();
        return (react_1.default.createElement(lib_1.Grid, { align: ['center-xs'] },
            react_1.default.createElement(lib_1.GridColumn, { width: ['xs-12', 'md-10', 'lg-8'] },
                react_1.default.createElement(ContactFormHeader_1.default, { heading: this.heading })),
            react_1.default.createElement(lib_1.GridColumn, { width: ['xs-12', 'md-10', 'lg-8'] },
                react_1.default.createElement(ContactFormContent_1.default, { contactFormType: contactFormType, textAreaComment: this.textAreaComment })),
            react_1.default.createElement(lib_1.GridColumn, { width: ['xs-12', 'md-10', 'lg-8'] },
                react_1.default.createElement(ContactFormFooter_1.default, { redirectUrlAfterSubmit: redirectUrlAfterSubmit, isInsideModal: false }))));
    }
};
__decorate([
    mobx_1.observable
], ContactForm.prototype, "heading", void 0);
__decorate([
    mobx_1.observable
], ContactForm.prototype, "textAreaComment", void 0);
ContactForm = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], ContactForm);
exports.default = ContactForm;
